export type ValidationReport = {
  [s: string]: boolean;
}

export type ValidationErrors = string[];

export class Validator<TValue>
{
  constructor({ validationReport }: {
    validationReport?: (value: TValue) => ValidationReport,
  })
  {
    this.validationReport = validationReport || (() => ({}));
  }

  readonly validationReport: (value: TValue) => ValidationReport;

  readonly validationErrors = (value: TValue) => Object.entries(this.validationReport(value))
    .filter(([_, ruleResult]) => !ruleResult)
    .map(([ruleName, _]) => ruleName);

  readonly isValid = (value: TValue) => this.validationErrors(value).length === 0;
}

export function validator<TValue>(validationReport?: (record: TValue) => ValidationReport) {
  return new Validator({ validationReport })
}
